// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MakeProductAvailable_banner-message__2WM7C {
  align-items: flex-start;
}

.MakeProductAvailable_banner-title__zb3md {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.MakeProductAvailable_link__3ewyH {
  margin-top: 12px;
  color: #0058e1;
  text-decoration: none;
  background-color: transparent;
  font-size: 14px;
}

.MakeProductAvailable_link__3ewyH:hover {
  color: #003b9c;
  text-decoration-line: underline;
}

.MakeProductAvailable_popup__yyZ4v .MakeProductAvailable_popup-centered__QXM5e {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.MakeProductAvailable_popup__yyZ4v .MakeProductAvailable_popup-text__V2ywu {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
}
.MakeProductAvailable_popup__yyZ4v .MakeProductAvailable_popup-button__UJKT1 {
  display: flex;
  justify-content: flex-end;
}
.MakeProductAvailable_popup__yyZ4v .MakeProductAvailable_popup-button__UJKT1 Button {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/MakeProductAvailable/MakeProductAvailable.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAGA;EACE,uBAAA;AAFF;;AAKA;EACE,eCNO;EDOP,iBCFK;EDGL,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cEOU;EFNV,qBAAA;EACA,6BAAA;EACA,eCjBO;ADeT;;AAKA;EACE,cECgB;EFAhB,+BAAA;AAFF;;AAME;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAKE;EACE,aAAA;EACA,yBAAA;AAHJ;AAII;EACE,iBClCC;ADgCP","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.banner-message {\n  align-items: flex-start;\n}\n\n.banner-title {\n  font-size: typography.$body-l;\n  font-weight: typography.$bold;\n  margin-bottom: 8px;\n}\n\n.link {\n  margin-top: 12px;\n  color: colors.$text-link;\n  text-decoration: none;\n  background-color: transparent;\n  font-size: typography.$body-m;\n}\n\n.link:hover {\n  color: colors.$text-link-hover;\n  text-decoration-line: underline;\n}\n\n.popup {\n  .popup-centered {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .popup-text {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n  .popup-button {\n    display: flex;\n    justify-content: flex-end;\n    Button {\n      font-weight: typography.$bold;\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner-message": `MakeProductAvailable_banner-message__2WM7C`,
	"banner-title": `MakeProductAvailable_banner-title__zb3md`,
	"link": `MakeProductAvailable_link__3ewyH`,
	"popup": `MakeProductAvailable_popup__yyZ4v`,
	"popup-centered": `MakeProductAvailable_popup-centered__QXM5e`,
	"popup-text": `MakeProductAvailable_popup-text__V2ywu`,
	"popup-button": `MakeProductAvailable_popup-button__UJKT1`
};
export default ___CSS_LOADER_EXPORT___;
